function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5 4.5A3.5 3.5 0 0 1 20 8v8a3.5 3.5 0 0 1-3.5 3.5h-8a3.5 3.5 0 0 1-3.464-3H3.5V15H5V9.5H3.5V8H5a3.5 3.5 0 0 1 3.5-3.5zm0 1.5h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z",
  fill: "#999",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 7a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h8zm-5.44 2.854a.5.5 0 1 0-.706.707l.398.398a1.99 1.99 0 0 0-.277 1.016c0 .37.1.718.276 1.015l-.397.4a.5.5 0 1 0 .707.706l.398-.398a1.99 1.99 0 0 0 1.016.277c.37 0 .718-.101 1.015-.277l.4.398a.5.5 0 0 0 .706-.707l-.398-.399a1.99 1.99 0 0 0 .277-1.015 1.99 1.99 0 0 0-.277-1.016l.398-.398a.5.5 0 0 0-.707-.707l-.399.397a1.99 1.99 0 0 0-1.015-.276 1.99 1.99 0 0 0-1.016.277zm1.415 1.12a1 1 0 1 1 0 2 1 1 0 0 1 0-2z",
  fill: "#666"
}));

function SvgIco24GnbFinixN(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco24GnbFinixN);
export default __webpack_public_path__ + "static/media/ico_24_gnb_finix_n.e1753c6e.svg";
export { ForwardRef as ReactComponent };